import { Injectable } from '@angular/core';
import { ResetPassword } from "../reset-password/reset-password.model";

import { JsonApiService } from "../../../core/api/json-api.service";
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ResetPasswordService {

    public data: Subject<any>;

    constructor(private jsonApiService: JsonApiService) {
        this.data = new Subject();
    }

    resetPassword(resetPasswordInfo: ResetPassword): Observable<any> {
        return this.jsonApiService.post('/Account/resetpassword', resetPasswordInfo);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/reset-password/reset-password.service.ts